import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';

export function formatDurationHuman(seconds: number) {
  dayjs.extend(duration);
  const date = dayjs.duration(seconds, 'seconds');

  const hours = Math.floor(date.asHours());
  const minutes = date.minutes();
  const secs = date.seconds();

  const parts: string[] = [];

  if (hours > 0) {
    parts.push(`${hours} h`);
  }

  if (minutes > 0 || hours > 0) {
    parts.push(`${minutes} min`);
  }

  parts.push(`${secs} s`);

  return parts.join(' ');
}
